__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "reference-soa-ui-service";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@procore/core-http", "10.2.0", function() { return __webpack_require__.e(508).then(function() { return function() { return __webpack_require__(4508); }; }); });
			register("@procore/core-i18n-js", "10.25.0", function() { return __webpack_require__.e(64).then(function() { return function() { return __webpack_require__(7064); }; }); });
			register("@procore/core-react", "10.25.0", function() { return __webpack_require__.e(601).then(function() { return function() { return __webpack_require__(7601); }; }); });
			register("formik", "2.2.9", function() { return __webpack_require__.e(445).then(function() { return function() { return __webpack_require__(3445); }; }); });
			register("miragejs", "0.1.43", function() { return __webpack_require__.e(10).then(function() { return function() { return __webpack_require__(9010); }; }); });
			register("react-dom", "18.1.0", function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(8368); }; }); });
			register("react-router-dom", "6.2.2", function() { return __webpack_require__.e(65).then(function() { return function() { return __webpack_require__(2065); }; }); });
			register("react", "18.1.0", function() { return __webpack_require__.e(750).then(function() { return function() { return __webpack_require__(1750); }; }); });
			register("styled-components", "5.3.3", function() { return __webpack_require__.e(674).then(function() { return function() { return __webpack_require__(6674); }; }); });
			register("uuid", "8.3.2", function() { return __webpack_require__.e(861).then(function() { return function() { return __webpack_require__(7861); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};